var _a, _b, _c, _d, _e, _f, _g;
import { urlParse } from '../url';
import BrowserParser from './parser';
export const ua = window.navigator.userAgent;
const browser = new BrowserParser(ua);
export const isMobile = (_b = (_a = window._GATEWAY_UA) === null || _a === void 0 ? void 0 : _a.loadMobile) !== null && _b !== void 0 ? _b : ((_e = (_d = (_c = window.navigator) === null || _c === void 0 ? void 0 : _c.userAgent) === null || _d === void 0 ? void 0 : _d.toLocaleLowerCase()) === null || _e === void 0 ? void 0 : _e.indexOf('mobile')) > -1;
export const isPC = (_g = (_f = window._GATEWAY_UA) === null || _f === void 0 ? void 0 : _f.loadPC) !== null && _g !== void 0 ? _g : !isMobile;
export const getBrowserName = browser.getBrowserName.bind(browser);
export const getBrowserVersion = browser.getBrowserVersion.bind(browser);
/**
 * 获取客户端/浏览器信息
 */
export const getClientInfo = () => {
    var _a, _b, _c;
    const { __next_lowcode_mobile__ } = urlParse(window.location.href, true, true).query;
    const userAgent = ((_a = window.navigator) === null || _a === void 0 ? void 0 : _a.userAgent) || '';
    const isMobile = __next_lowcode_mobile__ === 'true' ||
        ((_c = (_b = window._GATEWAY_UA) === null || _b === void 0 ? void 0 : _b.loadMobile) !== null && _c !== void 0 ? _c : userAgent.toLocaleLowerCase().indexOf('mobile') > -1);
    return {
        isMobile,
        isPC: !isMobile,
        userAgent,
    };
};
